import {
  DefaultParameterCollection,
  DefaultParameterCollectionFromJSON,
  DefaultParameterInterLibraryLoan,
  DefaultParameterInterLibraryLoanFromJSON,
  DefaultParameterOrder,
  DefaultParameterOrderFromJSON,
  DefaultParameterOrderList,
  DefaultParameterOrderListFromJSON,
  DeleteDefaultParameterCollectionRequest,
  DeleteDefaultParameterCollectionRequestToJSON,
  DeleteDefaultParameterInterLibraryLoanRequest,
  DeleteDefaultParameterInterLibraryLoanRequestToJSON,
  DeleteDefaultParameterOrderListRequest,
  DeleteDefaultParameterOrderListRequestToJSON,
  DeleteDefaultParameterOrderRequest,
  DeleteDefaultParameterOrderRequestToJSON,
  GetDefaultParameterCollectionsRequest,
  GetDefaultParameterCollectionsRequestToJSON,
  GetDefaultParameterInterLibraryLoanRequest,
  GetDefaultParameterInterLibraryLoanRequestToJSON,
  GetDefaultParameterOrderListRequest,
  GetDefaultParameterOrderListRequestToJSON,
  GetDefaultParameterOrderRequest,
  GetDefaultParameterOrderRequestToJSON,
  HTTPBody,
  HTTPQuery,
  RegisterDefaultParameterCollectionRequest,
  RegisterDefaultParameterCollectionRequestToJSON,
  RegisterDefaultParameterInterLibraryLoanRequest,
  RegisterDefaultParameterInterLibraryLoanRequestToJSON,
  RegisterDefaultParameterOrderListRequest,
  RegisterDefaultParameterOrderListRequestToJSON,
  RegisterDefaultParameterOrderRequest,
  RegisterDefaultParameterOrderRequestToJSON,
  UpdateDefaultParameterCollectionDefaultValueRequest,
  UpdateDefaultParameterCollectionDefaultValueRequestToJSON,
  UpdateDefaultParameterCollectionRequest,
  UpdateDefaultParameterCollectionRequestToJSON,
  UpdateDefaultParameterInterLibraryLoanDefaultValueRequest,
  UpdateDefaultParameterInterLibraryLoanDefaultValueRequestToJSON,
  UpdateDefaultParameterInterLibraryLoanRequest,
  UpdateDefaultParameterInterLibraryLoanRequestToJSON,
  UpdateDefaultParameterOrderDefaultValueRequest,
  UpdateDefaultParameterOrderDefaultValueRequestToJSON,
  UpdateDefaultParameterOrderListDefaultValueRequest,
  UpdateDefaultParameterOrderListDefaultValueRequestToJSON,
  UpdateDefaultParameterOrderListRequest,
  UpdateDefaultParameterOrderListRequestToJSON,
  UpdateDefaultParameterOrderRequest,
  UpdateDefaultParameterOrderRequestToJSON,
  VoidApiResponse
} from '@/api'
import * as runtime from '../runtime'

export class DefaultParameterApi extends runtime.BaseAPI {
  /**
   * 資料登録初期値を取得する
   * 資料登録初期値取得
   */
  async getDefaultParameterCollections(
    request: GetDefaultParameterCollectionsRequest
  ): Promise<DefaultParameterCollection[]> {
    const queryParameters: HTTPQuery = GetDefaultParameterCollectionsRequestToJSON(
      request
    )
    const response = await this.requestGet(
      '/default-parameter/collections',
      queryParameters
    )

    return new runtime.JSONApiResponse(response, jsonValue =>
      jsonValue.map(DefaultParameterCollectionFromJSON)
    ).value()
  }

  /**
   * 資料登録初期値既定値を更新する
   * 資料登録初期値既定値更新
   */
  async updateDefaultParameterCollectionDefaultValue(
    request: UpdateDefaultParameterCollectionDefaultValueRequest
  ): Promise<VoidApiResponse> {
    const bodyParameters: HTTPBody = UpdateDefaultParameterCollectionDefaultValueRequestToJSON(
      request
    )
    const response = await this.requestPut(
      `/default-parameter/collections/${bodyParameters.id}/default`,
      bodyParameters
    )

    return new runtime.VoidApiResponse(response)
  }

  /**
   * 資料登録初期値を登録する
   * 資料登録初期値登録
   */
  async registerDefaultParameterCollection(
    request: RegisterDefaultParameterCollectionRequest
  ): Promise<VoidApiResponse> {
    const bodyParameters: HTTPBody = RegisterDefaultParameterCollectionRequestToJSON(
      request
    )
    const response = await this.requestPost(
      '/default-parameter/collections',
      bodyParameters
    )

    return new runtime.VoidApiResponse(response)
  }

  /**
   * 資料登録初期値を更新する
   * 資料登録初期値更新
   */
  async updateDefaultParameterCollection(
    request: UpdateDefaultParameterCollectionRequest
  ): Promise<VoidApiResponse> {
    const bodyParameters: HTTPBody = UpdateDefaultParameterCollectionRequestToJSON(
      request
    )
    const response = await this.requestPut(
      `/default-parameter/collections/${bodyParameters.id}`,
      bodyParameters
    )

    return new runtime.VoidApiResponse(response)
  }

  /**
   * 資料登録初期値を削除する
   * 資料登録初期値削除
   */
  async deleteDefaultParameterCollection(
    request: DeleteDefaultParameterCollectionRequest
  ): Promise<VoidApiResponse> {
    const bodyParameters: HTTPBody = DeleteDefaultParameterCollectionRequestToJSON(
      request
    )
    const response = await this.requestDelete(
      `/default-parameter/collections/${bodyParameters.id}`,
      bodyParameters
    )

    return new runtime.VoidApiResponse(response)
  }

  /**
   * 発注の初期値を取得する
   * 発注初期値取得
   */
  async getDefaultParameterOrder(
    request: GetDefaultParameterOrderRequest
  ): Promise<DefaultParameterOrder[]> {
    const queryParameters: HTTPQuery = GetDefaultParameterOrderRequestToJSON(
      request
    )
    const response = await this.requestGet(
      '/default-parameter/order',
      queryParameters
    )

    return new runtime.JSONApiResponse(response, jsonValue =>
      jsonValue.map(DefaultParameterOrderFromJSON)
    ).value()
  }

  /**
   * 発注の初期値既定値を更新する
   * 発注初期値既定値更新
   */
  async updateDefaultParameterOrderDefaultValue(
    request: UpdateDefaultParameterOrderDefaultValueRequest
  ): Promise<VoidApiResponse> {
    const bodyParameters: HTTPBody = UpdateDefaultParameterOrderDefaultValueRequestToJSON(
      request
    )
    const response = await this.requestPut(
      `/default-parameter/order/${bodyParameters.id}/default`,
      bodyParameters
    )

    return new runtime.VoidApiResponse(response)
  }

  /**
   * 発注の初期値を登録する
   * 発注初期値登録
   */
  async registerDefaultParameterOrder(
    request: RegisterDefaultParameterOrderRequest
  ): Promise<VoidApiResponse> {
    const bodyParameters: HTTPBody = RegisterDefaultParameterOrderRequestToJSON(
      request
    )
    const response = await this.requestPost(
      '/default-parameter/order',
      bodyParameters
    )

    return new runtime.VoidApiResponse(response)
  }

  /**
   * 発注の初期値を更新する
   * 発注初期値更新
   */
  async updateDefaultParameterOrder(
    request: UpdateDefaultParameterOrderRequest
  ): Promise<VoidApiResponse> {
    const bodyParameters: HTTPBody = UpdateDefaultParameterOrderRequestToJSON(
      request
    )
    const response = await this.requestPut(
      `/default-parameter/order/${bodyParameters.id}`,
      bodyParameters
    )

    return new runtime.VoidApiResponse(response)
  }

  /**
   * 発注の初期値を削除する
   * 発注初期値削除
   */
  async deleteDefaultParameterOrder(
    request: DeleteDefaultParameterOrderRequest
  ): Promise<VoidApiResponse> {
    const bodyParameters: HTTPBody = DeleteDefaultParameterOrderRequestToJSON(
      request
    )
    const response = await this.requestDelete(
      `/default-parameter/order/${bodyParameters.id}`,
      bodyParameters
    )

    return new runtime.VoidApiResponse(response)
  }

  /**
   * 発注リストの初期値を取得する
   * 発注リスト初期値取得
   */
  async getDefaultParameterOrderList(
    request: GetDefaultParameterOrderListRequest
  ): Promise<DefaultParameterOrderList[]> {
    const queryParameters: HTTPQuery = GetDefaultParameterOrderListRequestToJSON(
      request
    )
    const response = await this.requestGet(
      '/default-parameter/order-list',
      queryParameters
    )

    return new runtime.JSONApiResponse(response, jsonValue =>
      jsonValue.map(DefaultParameterOrderListFromJSON)
    ).value()
  }

  /**
   * 発注リスト初期値既定値を更新する
   * 発注リスト初期値既定値更新
   */
  async updateDefaultParameterOrderListDefaultValue(
    request: UpdateDefaultParameterOrderListDefaultValueRequest
  ): Promise<VoidApiResponse> {
    const bodyParameters: HTTPBody = UpdateDefaultParameterOrderListDefaultValueRequestToJSON(
      request
    )
    const response = await this.requestPut(
      `/default-parameter/order-list/${bodyParameters.id}/default`,
      bodyParameters
    )

    return new runtime.VoidApiResponse(response)
  }

  /**
   * 発注リスト初期値を登録する
   * 発注リスト初期値登録
   */
  async registerDefaultParameterOrderList(
    request: RegisterDefaultParameterOrderListRequest
  ): Promise<VoidApiResponse> {
    const bodyParameters: HTTPBody = RegisterDefaultParameterOrderListRequestToJSON(
      request
    )
    const response = await this.requestPost(
      '/default-parameter/order-list',
      bodyParameters
    )

    return new runtime.VoidApiResponse(response)
  }

  /**
   * 発注リスト初期値を更新する
   * 発注リスト初期値更新
   */
  async updateDefaultParameterOrderList(
    request: UpdateDefaultParameterOrderListRequest
  ): Promise<VoidApiResponse> {
    const bodyParameters: HTTPBody = UpdateDefaultParameterOrderListRequestToJSON(
      request
    )
    const response = await this.requestPut(
      `/default-parameter/order-list/${bodyParameters.id}`,
      bodyParameters
    )

    return new runtime.VoidApiResponse(response)
  }

  /**
   * 発注リスト初期値を削除する
   * 発注リスト初期値削除
   */
  async deleteDefaultParameterOrderList(
    request: DeleteDefaultParameterOrderListRequest
  ): Promise<VoidApiResponse> {
    const bodyParameters: HTTPBody = DeleteDefaultParameterOrderListRequestToJSON(
      request
    )
    const response = await this.requestDelete(
      `/default-parameter/order-list/${bodyParameters.id}`,
      bodyParameters
    )

    return new runtime.VoidApiResponse(response)
  }

  /**
   * 相互貸借の初期値を取得する
   * 相互貸借初期値取得
   */
  async getDefaultParameterInterLibraryLoan(
    request: GetDefaultParameterInterLibraryLoanRequest
  ): Promise<DefaultParameterInterLibraryLoan[]> {
    const queryParameters: HTTPQuery = GetDefaultParameterInterLibraryLoanRequestToJSON(
      request
    )
    const response = await this.requestGet(
      '/default-parameter/interlibrary-loan',
      queryParameters
    )

    return new runtime.JSONApiResponse(response, jsonValue =>
      jsonValue.map(DefaultParameterInterLibraryLoanFromJSON)
    ).value()
  }

  /**
   * 相互貸借初期値既定値を更新する
   * 相互貸借初期値既定値更新
   */
  async updateDefaultParameterInterLibraryLoanDefaultValue(
    request: UpdateDefaultParameterInterLibraryLoanDefaultValueRequest
  ): Promise<VoidApiResponse> {
    const bodyParameters: HTTPBody = UpdateDefaultParameterInterLibraryLoanDefaultValueRequestToJSON(
      request
    )
    const response = await this.requestPut(
      `/default-parameter/interlibrary-loan/${bodyParameters.id}/default`,
      bodyParameters
    )

    return new runtime.VoidApiResponse(response)
  }

  /**
   * 相互貸借初期値を登録する
   * 相互貸借初期値登録
   */
  async registerDefaultParameterInterLibraryLoan(
    request: RegisterDefaultParameterInterLibraryLoanRequest
  ): Promise<VoidApiResponse> {
    const bodyParameters: HTTPBody = RegisterDefaultParameterInterLibraryLoanRequestToJSON(
      request
    )
    const response = await this.requestPost(
      '/default-parameter/interlibrary-loan',
      bodyParameters
    )

    return new runtime.VoidApiResponse(response)
  }

  /**
   * 相互貸借初期値を更新する
   * 相互貸借初期値更新
   */
  async updateDefaultParameterInterLibraryLoan(
    request: UpdateDefaultParameterInterLibraryLoanRequest
  ): Promise<VoidApiResponse> {
    const bodyParameters: HTTPBody = UpdateDefaultParameterInterLibraryLoanRequestToJSON(
      request
    )
    const response = await this.requestPut(
      `/default-parameter/interlibrary-loan/${bodyParameters.id}`,
      bodyParameters
    )

    return new runtime.VoidApiResponse(response)
  }

  /**
   * 相互貸借初期値を削除する
   * 相互貸借初期値削除
   */
  async deleteDefaultParameterInterLibraryLoan(
    request: DeleteDefaultParameterInterLibraryLoanRequest
  ): Promise<VoidApiResponse> {
    const bodyParameters: HTTPBody = DeleteDefaultParameterInterLibraryLoanRequestToJSON(
      request
    )
    const response = await this.requestDelete(
      `/default-parameter/interlibrary-loan/${bodyParameters.id}`,
      bodyParameters
    )

    return new runtime.VoidApiResponse(response)
  }
}
